<template>
  <div class="project-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="6">
            <el-form-item :label="$t('manage.project_name')">
              <el-input v-model="filter.project_name" :placeholder="$t('manage.keywords')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="project_id" :label="$t('manage.project_id')" width="140"></el-table-column>
        <el-table-column prop="project_name" :label="$t('manage.project_name')" width="300"></el-table-column>
        <el-table-column v-if="$store.state.user.role_type==1" prop="company_name" :label="$t('manage.company')" width="360"></el-table-column>
        <el-table-column :label="$t('manage.system_logo')" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.logo" class="list-pic"><img :src="scope.row.logo" class="img" /></div>
            <div v-else class="list-pic-none">None</div>
          </template>
        </el-table-column>
        <el-table-column prop="belong_person_name" :label="$t('manage.project_manager')" width="180"></el-table-column>
        <el-table-column :label="$t('manage.project_address')" width="260">
          <template slot-scope="scope">
            <div class="td-con">
              <div v-if="scope.row.province_name!=$t('manage.none')">
              {{ scope.row.province_name }}{{ scope.row.city_name }}{{ scope.row.district_name }}{{ scope.row.region_name }}
              <span v-if="scope.row.longitude&&scope.row.latitude"><svg-icon icon-class="local-map" class="pointer f18" @click="lookMapSite(scope.row.project_name, scope.row.longitude, scope.row.latitude)" /></span>
              </div>
              <div v-else>暂无</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="max_access_count" :label="$t('manage.max_access')" width="160"></el-table-column>
        <el-table-column :label="$t('manage.access_status')" width="140">
          <template slot-scope="scope">
            <span>
              {{ access_status_arr[scope.row.access_status] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="expiry_date" :label="$t('manage.due_Date')" width="240"></el-table-column>
        <el-table-column prop="created_at" :label="$t('screen.add_time')" width="240">
          <template slot-scope="scope">
            <span>
              {{ formatDate(scope.row.created_at) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" fixed="right" width="160">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.project_id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog750"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
        ref="dialogRef"
        label-width="120px"
      >
        <div class="form-info">
          <el-form-item :label="$t('manage.project_name')" prop="project_name">
            <el-input v-model="editOne.project_name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('manage.company')" prop="company_id">
            <el-select
              :placeholder="$t('manage.company')"
              v-model="editOne.company_id"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="t in companyList"
                :key="t.company_id"
                :label="t.company_name"
                :value="t.company_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('manage.access_level')" prop="access_status">
            <el-select
              :placeholder="$t('manage.access_level')"
              v-model="editOne.access_status"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="(t, index) in access_status_arr"
                :key="index"
                :label="t"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('manage.max_access')" prop="max_access_count">
            <el-input v-model="editOne.max_access_count" type="number"></el-input>
          </el-form-item>

          <el-form-item :label="$t('manage.due_Date')" prop="expiry_date">
            <el-date-picker
            v-model="editOne.expiry_date"
            type="date"
            :placeholder="$t('manage.due_Date')"
            :picker-options="pickerOptions"
            @change="clearChange"
            >
          </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('manage.system_logo')" class="upload-box">
            <el-upload
              ref="upload"
              name="file"
              :action="uploadAction()"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
              :headers="{'Authorization': token}"
              :data="{'type': 1}"
              :on-remove="handleRemove"
              :beforeUpload="beforeFilesUpload"
              :on-success="handleFilesSuccess"
            >
              <el-button size="small" type="primary">{{$t('manage.upload')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('manage.pic_tip')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('manage.title')" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>
          <div class="address-box">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('manage.province')" prop="province_id">
                  <el-select v-model="editOne.province_id" :placeholder="$t('manage.province')" @change="getCity" style="width: 100%;" size="small">
                    <el-option
                      v-for="(item,index) of addressObj.provinceArr"
                      :key="index"
                      :label="item.area_name"
                      :value="item.area_id"
                      ></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('manage.city')" prop="city_id">
                  <el-select v-model="editOne.city_id" :placeholder="$t('manage.city')" @change="getArea" style="width: 100%;" size="small">
                    <el-option
                      v-for="(item,index) of addressObj.cityArr"
                      :key="index"
                      :label="item.area_name"
                      :value="item.area_id"
                      ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('manage.area')" prop="district_id">
                    <el-select v-model="editOne.district_id" :placeholder="$t('manage.area')"  style="width: 100%;" size="small">
                      <el-option
                        v-for="(item,index) of addressObj.areaArr"
                        :key="index"
                        :label="item.area_name"
                        :value="item.area_id"
                      ></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form-item :label="$t('manage.address')" prop="region_name">
            <el-input v-model="editOne.region_name"></el-input>
          </el-form-item>
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item :label="$t('control.longitude')" class="lnglat-input">
                <el-input v-model="editOne.longitude" @input="onInput()" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('control.latitude')" class="lnglat-input">
                <el-input v-model="editOne.latitude" @input="onInput()" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="map-box">
                <amap :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import projectApi from "@/api/system/project";
import publicApi from "@/api/system/public";
import companyApi from "@/api/system/company";
import commonJs from '@/utils/common'
import { getToken } from '@/utils/auth'
import amap from '@/components/addMap'
import store from '@/store'
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  components: {
    amap
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      companyList: [],
      pageInfo: {
        sortBy: 'project_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        company_name: ''
      },
      cnt_all: 0,
      editOneRule: {
        project_name: [{ required: true, message: this.$t('manage.project_name'), trigger: "blur" }],
        company_id: [{ required: true, message: this.$t('manage.company'), trigger: "blur" }],
      },
      access_status_arr: this.$t('manage.access_status_arr'),
      editType: -1,
      editOne: {
        project_name: '',
        company_id: '',
        belong_person: 0,
        access_status: 2,
        max_access_count: 1000,
        expiry_date: 1000,
        logo: '',
        title: '',
        province_id: '',
        city_id: '',
        district_id: '',
        region_name: '',
        longitude: '',
        latitude: ''
      },
      addressObj: {
        provinceArr: [],
        cityArr: [],
        areaArr: []
      },
      token: getToken(),
      fileList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [{
            text: this.$t('manage.today'),
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
          text: this.$t('manage.after_month1'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 1);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('manage.after_month3'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('manage.after_month6'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 6);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('manage.after_year1'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 12);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('manage.after_year2'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: this.$t('manage.forever'),
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 2400);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },
  async created() {
    await this.getProvince()
    this.getTableData(this.pageInfo.page)
    this.getCompanyList()
  },
  methods: {
    // 获取省份列表
    async getProvince() {
      await publicApi.getProvinceList().then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.provinceArr = res.data.data
          this.editOne.province_id =''
          if(this.addressObj.provinceArr.length){
            this.getCity(this.addressObj.provinceArr[0].area_id, '', '')
          }
        }
      })
    },
    // 获取城市列表
    async getCity(province_id, city_id, district_id) {
      await publicApi.getCityList({
        province: province_id
      }).then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.cityArr = res.data.data
          let g_city_id = this.addressObj.cityArr[0].area_id
          if(city_id){
            this.editOne.city_id = city_id
            g_city_id = city_id
          }else{
            this.editOne.city_id = ''
          }
          if(this.addressObj.cityArr.length){
            this.getArea(g_city_id, district_id)
          }
        }
      })
    },
    // 获取区域列表
    getArea(city_id, district_id) {
      publicApi.getAreaList({
          city: city_id
        }).then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.areaArr = res.data.data
          if(district_id){
            this.editOne.district_id = district_id
          }else{
            this.editOne.district_id = ''
          }
        }
      })
    },
    // 获取列表
    getTableData(pageIndex) {
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      projectApi.getProject(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getCompanyList() {
      companyApi.getCompany({
        sortBy: 'company_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      }).then((res) => {
        let resData = res.data.data;
        this.companyList = resData.list;
      });
    },
    async openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          project_name: '',
          company_id: '',
          belong_person: 0,
          access_status: 2,
          max_access_count: 1000,
          expiry_date: 1000,
          logo: '',
          title: '',
          province_id: '',
          city_id: '',
          district_id: '',
          region_name: '',
          longitude: '',
          latitude: ''
        };
        this.fileList= []
        let lngLat = ACCOUNT_MAP.center
        if(lngLat&&lngLat.length){
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
        }
        this.editType = "create";
      } else {
        if(index.province_id){
          await this.getCity(index.province_id, index.city_id, index.district_id)
        }
        this.editOne = {
          project_id: index.project_id,
          project_name: index.project_name,
          company_id: index.company_id,
          belong_person: index.belong_person,
          access_status: index.access_status,
          max_access_count: index.max_access_count,
          expiry_date: index.expiry_date,
          logo: index.logo,
          title: index.title,
          province_id: index.province_id,
          city_id: index.city_id,
          district_id: index.district_id,
          region_name: index.region_name,
          longitude: index.longitude,
          latitude: index.latitude
        }
        if(index.logo){
          this.fileList[0] = {
            name: index.project_name,
            url: index.logo
          }
        }else{
          this.fileList= []
        }
        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng&&!lat){
          lngLat = ACCOUNT_MAP.center
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
        }
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          projectApi.projectEdit(this.editOne.company_id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          projectApi.projectAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    delItem(id) {
      this.$confirm(this.$t('manage.del_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          projectApi.projectDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    getCoordinate(map) {
      // console.log('getCoordinate_map', map)
      this.editOne.longitude = map.lng
      this.editOne.latitude = map.lat
    },
    onInput() {
      this.$forceUpdate();
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/system/uploadFile';
    },
    handleRemove() {
      this.fileList = []
      this.editOne.logo = ''
    },
    beforeFilesUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "png";
      if (!extension) {
        this.$message({
          message: this.$t('manage.png_tip'),
          type: "error",
        });
      }
      return extension;
    },
    handleFilesSuccess(res, file) {
      if (res.data.code === 1000) {
        this.$message.success(this.$t("control.upload_success"));
        this.editOne.logo = res.data.data.file_url;
        this.fileList[0]=res.data.data.file_url;
      } else {
        this.$message.error(this.$t("control.error") + res.data.message);
      }
    },
    lookMapSite(index) {
      if (index.longitude && index.latitude) {
        this.mapSite = {
          name: index.name,
          lnglat: [index.longitude, index.latitude],
          visible: true
        }
      } else {
        this.$message.error(this.$t("manage.lnglat_none"))
        return
      }
    },
    closeMapSite() {
      this.mapSite = {
        name: '',
        lnglat: [],
        visible: false
      }
    },
    formatDate(date) {
      return commonJs.formatDate(date);
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.editOne.expiry_date = ''
        })
      }
    }
    
  }
};
</script>
<style lang='less'>
.project-page {
  width: 100%;
}
</style>